export const DAYS_IN_WEEK = 7;
export const DAYS_IN_MONTH = 30;

export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;
export const WEEK_MS = DAYS_IN_WEEK * DAY_MS;
export const MONTH_AS_30D_MS = DAYS_IN_MONTH * DAY_MS;

export const PAST_DATE = new Date(0);
export const ZERO_DATE = '0001-01-01T00:00:00Z';
export const FOREVER_DATE = '8307-10-01T19:33:20Z';

// важно указывать статические импорты, чтобы не грузились все локали
export const mapLocaleToImport = {
  ru: () => import('dayjs/locale/ru.js'),
};

export type AvailableLocales = keyof typeof mapLocaleToImport;
